import React from 'react';

// Shared folder glyph used by both the media-library sidebar and the
// "Add to folder" context menu so they stay visually identical.
const FolderIcon = ({ className }) =>
<svg className={className} width="16" height="14" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.4 0C0.627 0 0 0.627 0 1.4V10.6C0 11.373 0.627 12 1.4 12H12.6C13.373 12 14 11.373 14 10.6V2.8C14 2.027 13.373 1.4 12.6 1.4H7L5.6 0H1.4Z" fill="currentColor" />
  </svg>;

export default FolderIcon;
